/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PatientViewModel } from './PatientViewModel'; 

export function getPatientOptions(patientId: string, onSuccess?: (result: PatientViewModel) => void) {
	return queryOptions({
		queryKey: ['patient', patientId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/intake/patients/queries/getpatient/' + patientId;
			const resp = await axios.get<PatientViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(patientId)
	});
}